import { TThematique } from '../../types/types';
export const thematiques: TThematique[] = [
  {
    id: 'rec5aDqcPzLSRDCjl',
    name: 'VENTILATION',
    thematique: 'CVC',
    characterImg: 'img_miniature_cyril.png',
    characterName: 'Cyril',
    order: 6,
  },
  {
    id: 'recFzRoWp0l4gIfAz',
    name: 'ECLAIRAGES',
    thematique: 'ECLAIRAGES',
    characterImg: 'img_miniature_eva.png',
    characterName: 'Eva',
    order: 3,
  },
  {
    id: 'recRfOJw12fM7nxZY',
    name: 'SORBONNES',
    thematique: 'SORBONNES',
    characterImg: 'img_miniature_sorbonne.png',
    characterName: 'Sonia',
    order: 4,
  },
  {
    id: 'rece60b57kHj49SWF',
    name: 'STORES',
    thematique: 'STORES',
    characterImg: 'img_miniature_sami.png',
    characterName: 'Sami',
    order: 2,
  },
  {
    id: 'recmOjpjdgjLAKIyf',
    name: "CONTRÔLES D'ACCES",
    thematique: 'CONTROLS',
    characterImg: 'img_miniature_carl.png',
    characterName: 'Carl',
    order: 5,
  },
  {
    id: 'recxWizyrW2ULB4gA',
    name: 'ASCENSEURS',
    thematique: 'ASCENSEURS',
    characterImg: 'img_miniature_alix.png',
    characterName: 'Alix',
    order: 1,
  },
];
